module.exports = __webpack_public_path__ + "static/seville-history-3-0688c91543c412153aa1805d2ebbf6c7.jpg";